const RSVPTitle=({ children }) => {
  return (
    <div className="my-3 row flex-nowrap" style={{flexDirection:"column"}}>
        <h4 className="text-uppercase text-center mx-auto float-none py-2 mb-0 px-0"
          style={{width:"auto", flexShrink:1, alignSelf:"center", color:"#000"}}
        >
          {children}
        </h4>
      </div>
  )
}

export default RSVPTitle;
